import * as fromDatatype from "../datatype-library/index";

export interface bl_fi_generic_doc_custom_processing_history_RowInterface
{
  guid: fromDatatype.GuidDataFieldInterface;
  custom_processing_queue_guid: fromDatatype.GuidDataFieldInterface;
  gendoc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  company_code: fromDatatype.VarcharDatatypeInterface;
  processor_code: fromDatatype.VarcharDatatypeInterface;
  gendoc_hdr_posting_status: fromDatatype.VarcharDatatypeInterface;
  gendoc_hdr_server_doc_type: fromDatatype.VarcharDatatypeInterface;
  gendoc_hdr_client_doc_type: fromDatatype.VarcharDatatypeInterface;
  external_document_type: fromDatatype.VarcharDatatypeInterface;
  external_document_code: fromDatatype.VarcharDatatypeInterface;
  external_submission_no: fromDatatype.VarcharDatatypeInterface;
  external_response_json: fromDatatype.JsonDatatypeInterface;
  descr: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
}

export class bl_fi_generic_doc_custom_processing_history_RowClass implements bl_fi_generic_doc_custom_processing_history_RowInterface
{
  guid: fromDatatype.GuidDataFieldInterface;
  custom_processing_queue_guid: fromDatatype.GuidDataFieldInterface;
  gendoc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  company_code: fromDatatype.VarcharDatatypeInterface;
  processor_code: fromDatatype.VarcharDatatypeInterface;
  gendoc_hdr_posting_status: fromDatatype.VarcharDatatypeInterface;
  gendoc_hdr_server_doc_type: fromDatatype.VarcharDatatypeInterface;
  gendoc_hdr_client_doc_type: fromDatatype.VarcharDatatypeInterface;
  external_document_type: fromDatatype.VarcharDatatypeInterface;
  external_document_code: fromDatatype.VarcharDatatypeInterface;
  external_submission_no: fromDatatype.VarcharDatatypeInterface;
  external_response_json: fromDatatype.JsonDatatypeInterface;
  descr: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
}